module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'row': true,
      'post': true,
      'self': parseInt(_vm.post.is_self_post),
        'origin': parseInt(_vm.post.is_origin_post),
        'has-reply': _vm.post.reply,
        'suggestion': (_vm.post.type === 'suggestion'),
        'comment': (_vm.post.type === 'comment'),
        'question': (_vm.post.type === 'question'),
        'locked': _vm.isComicLocked
    }
  }, [(_vm.post.type === 'suggestion') ? _c('div', {
    class: {
      'cell': true,
      'cell-vote': true,
      'cell-vote-up': parseInt(_vm.post.user_vote)
    },
    on: {
      "click": _vm.postVote
    }
  }, [_vm._v("\n    " + _vm._s(_vm.post.votes) + "\n    "), _c('span', {
    staticClass: "star"
  }, [_vm._v("\n      " + _vm._s(parseInt(_vm.post.user_vote) ? '★' : '☆') + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cell cell-username"
  }, [_vm._v("\n    " + _vm._s(_vm.post.username) + "\n    "), (
    (parseInt(_vm.post.is_self_post) && _vm.canDelete && !_vm.isComicLocked) ||
    (this.$store.state.user && this.$store.state.user.is_admin)
  ) ? _c('span', [_vm._v("\n      ("), _c('a', {
    staticClass: "cell-delete",
    on: {
      "click": _vm.deletePost
    }
  }, [_vm._v("delete")]), _vm._v(")\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.postError) ? _c('div', {
    staticClass: "twelve columns"
  }, [_c('p', [_vm._v(_vm._s(_vm.postError))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "twelve columns"
  }, [_c('div', {
    staticClass: "cell cell-text"
  }, [_vm._v("\n      " + _vm._s(_vm.post.text) + "\n    ")])]), _vm._v(" "), (_vm.post.reply) ? _c('div', {
    staticClass: "row reply"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "twelve columns"
  }, [_c('div', {
    staticClass: "cell cell-text",
    domProps: {
      "innerHTML": _vm._s(_vm.post.reply)
    }
  })])]) : _vm._e(), _vm._v(" "), (
    _vm.post.type !== 'suggestion' &&
    (this.$store.state.user && this.$store.state.user.is_admin)
  ) ? _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.reply),
      expression: "post.reply"
    }],
    staticClass: "edit-reply u-full-width",
    domProps: {
      "value": (_vm.post.reply)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.reply = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.editReply
    }
  }, [_vm._v("Edit")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twelve columns"
  }, [_c('div', {
    staticClass: "cell cell-username"
  }, [_vm._v("Reply")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b099247"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Post.vue
// module id = 270
// module chunks = 1